import { render, staticRenderFns } from "./ViaplyVerify.vue?vue&type=template&id=0f59e206&scoped=true&"
import script from "./ViaplyVerify.vue?vue&type=script&lang=js&"
export * from "./ViaplyVerify.vue?vue&type=script&lang=js&"
import style0 from "./ViaplyVerify.vue?vue&type=style&index=0&id=0f59e206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59e206",
  null
  
)

export default component.exports